import React, { Component } from 'react';
import { ConnectedProps, connect } from 'react-redux';
import { AppState } from '../../core/Store';
import * as Styles from './Styles';
import Banner from './banner/Banner';
import Files from './files/Files';

type State = {};

class DocumentsViewComponent extends Component<PropsFromRedux, State> {
	state = {};

	render() {
		return (
			<Styles.Wrapper>
				<Banner />
				<Files />
			</Styles.Wrapper>
		);
	}
}

interface Own {}

const connector = connect(
	(state: AppState, own: Own) => ({}),
	(dispatch) => ({})
);

export type PropsFromRedux = ConnectedProps<typeof connector> & Own;

const DocumentsView = connector(DocumentsViewComponent);
export default DocumentsView;
